import React, { useState, useEffect } from "react";
import axios from "../../api/axios";
import "./MyAccount.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "./Layout";

export default function MyAccount() {
    const [activeTab, setActiveTab] = useState("details");

    const userData = JSON.parse(localStorage.getItem("user"));
    const userId = userData?.id || userData?._id;

    // ================= PERSONAL =================
    const [personal, setPersonal] = useState({
        name: "",
        email: "",
        phone: "",
        whatsapp: "",
        currentLocation: "",
    });

    // ================= PASSWORD =================
    const [email, setEmail] = useState("");
    const [otpData, setOtpData] = useState({
        otp: "",
        newPassword: "",
    });

    // ================= LOAD USER =================
    useEffect(() => {
        if (userData) {
            setPersonal({
                name: userData.name || "",
                email: userData.email || "",
                phone: userData.phone || "",
                whatsapp: userData.whatsapp || "",
                currentLocation: userData.currentLocation || "",
            });

            setEmail(userData.email || "");
        }
    }, []);

    // ================= UPDATE PROFILE =================
    const handleUpdateProfile = async () => {
        try {
            const res = await axios.put(`/auth/update-profile/${userId}`, personal);

            localStorage.setItem("user", JSON.stringify(res.data.user));

            toast.success("Profile updated successfully");
        } catch (err) {
            toast.error(err.response?.data?.message || "Error updating profile");
        }
    };

    // ================= SEND OTP =================
    const handleSendOtp = async () => {
        if (!email) return toast.error("Enter email");

        try {
            await axios.post("/auth/forgot-password", { email });
            toast.success("OTP sent");
        } catch (err) {
            toast.error(err.response?.data?.message);
        }
    };

    // ================= RESET PASSWORD =================
    const handleReset = async () => {
        if (!otpData.otp || !otpData.newPassword) {
            return toast.error("Enter OTP & new password");
        }

        try {
            await axios.post("/auth/reset-password", {
                email,
                otp: otpData.otp,
                newPassword: otpData.newPassword,
            });

            toast.success("Password updated");

            setOtpData({ otp: "", newPassword: "" });
        } catch (err) {
            toast.error(err.response?.data?.message);
        }
    };

    return (
        <Layout>
            <div className="account-container">
                <ToastContainer />

                {/* HEADER */}
                <div className="account-header">
                    <div className="profile-img">
                        {personal.name?.charAt(0) || "U"}
                    </div>

                    <div className="text-center">
                        <h2>{personal.name}</h2>
                        <p>{personal.email}</p>
                    </div>
                </div>

                {/* TABS */}
                <div className="tabs">
                    <button
                        className={activeTab === "details" ? "active" : ""}
                        onClick={() => setActiveTab("details")}
                    >
                        Edit Account Details
                    </button>

                    <button
                        className={activeTab === "password" ? "active" : ""}
                        onClick={() => setActiveTab("password")}
                    >
                        Change Password
                    </button>
                </div>

                {/* CONTENT */}
                <div className="tab-content">

                    {/* ================= EDIT DETAILS ================= */}
                    {activeTab === "details" && (
                        <div className="form-box">

                            <label>Name</label>
                            <input
                                value={personal.name}
                                onChange={(e) =>
                                    setPersonal({ ...personal, name: e.target.value })
                                }
                            />

                           <label>Email</label>
<input
  value={personal.email}
  disabled
  className="readonly-input"
/>

<label>Phone</label>
<input
  value={personal.phone}
  disabled
  className="readonly-input"
/>




                            <button className="update-btn" onClick={handleUpdateProfile}>
                                Update Details
                            </button>

                        </div>
                    )}

                    {/* ================= PASSWORD ================= */}
                    {activeTab === "password" && (
                        <div className="form-box otp-box">

                            <input
                                type="email"
                                placeholder="Enter Email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />

                            <button className="btn-green" onClick={handleSendOtp}>
                                Send OTP
                            </button>

                            <input
                                placeholder="Enter OTP"
                                value={otpData.otp}
                                onChange={(e) =>
                                    setOtpData({ ...otpData, otp: e.target.value })
                                }
                            />

                            <input
                                type="password"
                                placeholder="New Password"
                                value={otpData.newPassword}
                                onChange={(e) =>
                                    setOtpData({
                                        ...otpData,
                                        newPassword: e.target.value,
                                    })
                                }
                            />

                            <button className="btn-green" onClick={handleReset}>
                                Reset Password
                            </button>

                        </div>
                    )}

                </div>
            </div>
        </Layout>
    );
}